import React, { useState } from "react";
// import "./CopyText.css";
import { RavenTextTrim } from "../helper/helper";
import { FaCheck } from "react-icons/fa";
import RavenToolTip from "../components/RavenToolTip";
import { colors } from "./variable";
export interface CopyProps {
  text?: string | number | undefined;
  trimNum?: number;
  copiedBgColor?: string;
  style?: React.CSSProperties;
  className?: string;
  copyValue?: string;
  checkColor?: string;
  copyIconBgColor?: string;
  color?: colors["value"];
  copyIconColor?: string;
  toolTipPosition?: TooltipPosition;
  onClick?(): void;
  stopPropagation?: boolean;
  clickable?: boolean;
  visibility?: boolean;
}
type TooltipPosition =
  | "top"
  | "top-center"
  | "top-right"
  | "top-left"
  | "left"
  | "bottom-right"
  | "bottom-left"
  | "right";
const RavenCopyText: React.FC<CopyProps> = ({
  text,
  trimNum,
  copiedBgColor,
  style,
  className,
  copyValue,
  checkColor,
  copyIconBgColor,
  color,
  copyIconColor,
  toolTipPosition,
  onClick,
  stopPropagation,
  clickable,
  visibility,
}) => {
  const [isCopied, setIsCopied] = useState("");
  const handleCopied = async (item) => {
    const flattenObject = (obj) => {
      return Object.entries(obj).flatMap(([key, value]) => {
        // Check if value is a stringified object (e.g. meta_data)
        if (typeof value === "string") {
          try {
            const parsed = JSON.parse(value);
            if (typeof parsed === "object" && parsed !== null) {
              return flattenObject(parsed); // Exclude parent key
            }
          } catch (_) {
            // Not a stringified object
          }
        }
        // If nested object, recurse
        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          return flattenObject(value);
        }
        return `${key}: ${value}`;
      });
    };
    let formatted = "";
    if (typeof item === "string" || typeof item === "number") {
      formatted = item.toString();
    } else if (Array.isArray(item)) {
      formatted = item
        .map((obj) => {
          if (
            typeof obj === "object" &&
            obj !== null &&
            "label" in obj &&
            "value" in obj
          ) {
            return `${obj.label}: ${obj.value}`;
          }
          return "";
        })
        .filter(Boolean)
        .join("\n");
    } else if (typeof item === "object" && item !== null) {
      const flattened = flattenObject(item);
      formatted = flattened.join("\n");
    } else {
      console.error("Unsupported value for clipboard copy.");
      return;
    }
    setIsCopied(formatted);
    try {
      await navigator.clipboard.writeText(formatted);
    } catch (err) {
      console.error("Clipboard write failed:", err);
    }
    setTimeout(() => {
      setIsCopied("");
    }, 1000);
  };
  const newCopyIcon = (
    <svg
      className="img"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={!copyIconColor ? "dull-bright-filter" : ""}
        d="M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z"
        stroke={copyIconColor || "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const wrapNum = trimNum || 20;
  return (
    <>
      <span
        className={`reusable-copy-text-fragment-box ${
          className ? className : ""
        } tooltip-hover-wrap`}
        style={style ? style : undefined}
        onClick={(e) => {
          if (stopPropagation || onClick) {
            e.stopPropagation();
            onClick && onClick();
          }
          clickable && handleCopied(copyValue || text);
        }}
      >
        {String(text)?.length >= wrapNum ? (
          <RavenToolTip
            color={color || "black-light"}
            position={toolTipPosition || "top-center"}
            text={text !== undefined ? String(text) : "------------"}
          />
        ) : (
          ""
        )}
        {text ? <span> {RavenTextTrim(text, wrapNum) || "---"}</span> : ""}
        {isCopied ? (
          <span
            style={{
              backgroundColor: copiedBgColor ? copiedBgColor : "#020202",
            }}
            className="copied-box-reciept"
          >
            {FaCheck({
              className: "icon",
              style: {
                fill: checkColor ? checkColor : "#ffffff",
              },
            })}
          </span>
        ) : (
          <figure
            onClick={() => handleCopied(copyValue || text)}
            className={`img-box-reciept ${visibility  ? 'always-visible' : ''}`}
            style={{
              backgroundColor: copyIconBgColor || "#F7F7F7",
            }}
          >
            {newCopyIcon}
          </figure>
        )}
      </span>
    </>
  );
};
export default RavenCopyText;
